import { FormField, FormRenderTypes } from "../Shared/Components/FormRenderer";
import { FormRenderGroupTypes } from "../Shared/Components/FormRenderer/FormRenderGroup.types";

export const categoryFields: FormField[] = [
	{
		name: "name",
		label: "Nazwa kategorii",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Wprowadź nazwę kategorii",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "description",
		label: "Opis kategorii",
		type: FormRenderTypes.wysiwyg,
		value: "",
		placeholder: "Wprowadź opis kategorii",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "slug",
		label: "Przyjazna nazwa dla wyszukiwarek",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Przyjazna nazwa dla wyszukiwarek",
		group: FormRenderGroupTypes.seo,
	},
	{
		name: "metaTitle",
		label: "Tytuł meta",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Wprowadź tytuł meta",
		group: FormRenderGroupTypes.seo,
	},
	{
		name: "metaDescription",
		label: "Opis meta",
		type: FormRenderTypes.textarea,
		value: "",
		placeholder: "Wprowadź opis meta",
		group: FormRenderGroupTypes.seo,
	},
	{
		name: "metaKeywords",
		label: "Słowa kluczowe meta",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Wprowadź słowa kluczowe meta",
		group: FormRenderGroupTypes.seo,
	},
	{
		name: "showOnHomePage",
		label: "Pokaż na stronie głównej",
		type: FormRenderTypes.switch,
		value: "",
		group: FormRenderGroupTypes.configuration,
	},
	{
		name: "includeInTopMenu",
		label: "Dołącz do menu górnego",
		type: FormRenderTypes.switch,
		value: "",
		group: FormRenderGroupTypes.configuration,
	},
	{
		name: "published",
		label: "Opublikowany",
		type: FormRenderTypes.switch,
		value: "",
		group: FormRenderGroupTypes.configuration,
	},
	{
		name: "displayOrder",
		label: "Kolejność wyświetlania",
		type: FormRenderTypes.number,
		value: "",
		placeholder: "Wprowadź kolejność wyświetlania",
		group: FormRenderGroupTypes.configuration,
	},
	{
		name: "parentCategoryId",
		label: "Wybierz kategorię nadrzędną",
		type: FormRenderTypes.autocomplete,
		value: "",
		placeholder: "Wybierz kategorię nadrzędną",
		group: FormRenderGroupTypes.basic,
	},
];
